<!-- 主题配置 -->
<template>
  <div class="themeCfg">
    <label class="el-form-item__label">模板区</label>
    <el-carousel height="150px" indicator-position="outside">
      <el-carousel-item v-for="item in carouselList" :key="item" style="cursor: pointer;"
                        @click="handleSelectTheme(item)">
        <img style="width: 100%; height: 100%;" :src="item.img" alt=""/>
      </el-carousel-item>
    </el-carousel>
    <label class="el-form-item__label">全局样式</label>
    <el-form-item label="主题模式">
      <el-radio-group v-model="theme.colorType" size="small">
        <el-radio label="light_color">浅色模式</el-radio>
        <el-radio label="deep_color">深色模式</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="主题颜色">
      <el-select
          filterable
          clearable
          v-model="theme.primaryColor"
      >
        <el-option
            label="中材红"
            value="red"
        ></el-option>
      </el-select>
    </el-form-item>
    <Color :prop="theme"></Color>
    <el-form-item label="字体类型">
      <el-select
          filterable
          allow-create
          v-model="theme.fontFamily"
      >
        <el-option
            v-for="item in dicOption.fontFamily"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="卡片圆角">
      <el-radio-group v-model="theme.borderRadius">
        <el-radio label="none">无</el-radio>
        <el-radio label="4">小</el-radio>
        <el-radio label="16">大</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="间距" label-width="80">
      <el-radio-group v-model="theme.gap" @change="handleThemeGapChange">
        <el-radio label="small">紧凑</el-radio>
        <el-radio label="normal">常规</el-radio>
        <el-radio label="self">自定义</el-radio>
      </el-radio-group>
    </el-form-item>
    <div class="card-margin" v-if="theme.gap === 'self'">
      <label class="el-form-item__label">卡片间间距</label>
      <div class="inline">
        <el-form-item label="行间距" label-width="70">
          <el-input-number size="small" v-model="theme.gapSet.rowGap" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="列间距" label-width="70">
          <el-input-number size="small" v-model="theme.gapSet.columnGap" :controls="false"></el-input-number>
        </el-form-item>
      </div>
      <label class="el-form-item__label">卡片内间距</label>
      <div class="inline">
        <el-form-item label="上" label-width="60">
          <el-input-number size="small" v-model="theme.gapSet.paddingTop" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="右" label-width="60">
          <el-input-number size="small" v-model="theme.gapSet.paddingRight" :controls="false"></el-input-number>
        </el-form-item>
      </div>
      <div class="inline">
        <el-form-item label="下" label-width="60">
          <el-input-number size="small" v-model="theme.gapSet.paddingBottom" :controls="false"></el-input-number>
        </el-form-item>
        <el-form-item label="左" label-width="60">
          <el-input-number size="small" v-model="theme.gapSet.paddingLeft" :controls="false"></el-input-number>
        </el-form-item>
      </div>
    </div>
    <div class="inline">
      <label class="el-form-item__label">
        <el-checkbox v-model="theme.refresh" label="刷新频率"/>
      </label>
      <el-input-number :min="0" size="small" v-model="theme.refreshFrequency" :controls="false"></el-input-number>
      <span style="font-size: 12px; margin-left: 5px;">分钟</span>
    </div>

    <div class="inline">
      <label class="el-form-item__label">
        数据请求合并
      </label>
      <el-input-number :min="10" :max="120" size="small" v-model="theme.limitApiNumber"
                       :controls="false"></el-input-number>
      <span style="font-size: 12px; margin-left: 5px;">个</span>
    </div>

    <el-form-item label="字体大小" style="margin-top: 12px;">
      <el-input-number v-model="theme.fontSize"></el-input-number>
    </el-form-item>
    <el-form-item label="演示模式" style="margin-top: 12px;">
      <el-switch v-model="theme.presentMode"></el-switch>
    </el-form-item>
    <label class="el-form-item__label">
      通用组件样式
    </label>
    <div v-if="showSetContent">
      <el-collapse accordion>
        <el-collapse-item title="标题类配置">
          <TitleConfig v-model="theme.titleSet"/>
        </el-collapse-item>
        <el-collapse-item title="图类配置">
          <ChartConfig v-model="theme.chartSet"/>
        </el-collapse-item>
        <el-collapse-item title="表格配置">
          <SheetConfig v-model="theme.sheetSet"/>
        </el-collapse-item>
        <el-collapse-item title="查询控件">
          <SearchConfig v-model="theme.searchSet"/>
        </el-collapse-item>
        <el-collapse-item title="图标配置">
          <IconsConfig v-model="theme.iconSet"/>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import bg1 from '@/assets/theme/bg1.jpg';
import bg2 from '@/assets/theme/bg2.jpg';
import bg3 from '@/assets/theme/bg3.jpg';
import bg4 from '@/assets/theme/bg4.jpg';
import bg5 from '@/assets/theme/bg5.jpg';
import Color from '@/option/components/commonSet/color.vue';
import {dicOption} from "@/option/config";
import TitleConfig from './themeSubComponent/titleConfig.vue'
import ChartConfig from './themeSubComponent/chartConfig.vue'
import SheetConfig from './themeSubComponent/sheetConfig.vue'
import SearchConfig from './themeSubComponent/searchConfig.vue'
import IconsConfig from './themeSubComponent/IconConfig.vue'

export default {
  name: "themeConfig",
  data() {
    return {
      dicOption: dicOption,
      showSetContent: false,
      theme: {
        colorType: '',
        colorIndex: '',
        fontColor: '',
        barColor: [],
        fontSize: '',
        fontFamily: '',
        gap: '',
        gapSet: {
          rowGap: '',
          columnGap: '',
          paddingTop: '',
          paddingRight: '',
          paddingBottom: '',
          paddingLeft: '',
        },
        refresh: '',
        refreshFrequency: '',
        limitApiNumber: '100',
        fontSize: '',
        titleSet: {},
        chartSet: {},
        sheetSet: {},
        searchSet: {},
        iconSet: {},
      },
      componentClass: [
        {
          label: '标题类配置',
          value: 'title',
        },
        {
          label: '图表类配置',
          value: 'chart',
        },
        {
          label: '查询类配置',
          value: 'search',
        },
        {
          label: '表格配置',
          value: 'sheet',
        }
      ],
      carouselList: [
        {
          name: '主题1',
          img: bg1,
        },
        {
          name: '主题2',
          img: bg2,
        },
        {
          name: '主题3',
          img: bg3,
        },
        {
          name: '主题4',
          img: bg4,
        },
        {
          name: '主题5',
          img: bg5,
        },
      ]
    };
  },
  props: {
    modelValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  inject: ["main"],
  components: {
    Color,
    TitleConfig,
    ChartConfig,
    SheetConfig,
    SearchConfig,
    IconsConfig
  },
  mounted() {
    if (!this.modelValue.iconSet) {
      this.modelValue.iconSet = {}
    }
    this.theme = {...this.theme, ...this.modelValue}
    this.showSetContent = true
  },
  watch: {
    theme: {
      deep: true,
      handler(val) {
        this.$emit('update:modelValue', val)
      },
    }
  },
  methods: {
    handleSelectTheme(item) {

    },
    handleThemeGapChange(val) {
      if (val === 'small') {
        this.theme.gapSet = {
          rowGap: 4,
          columnGap: 4,
          paddingTop: 4,
          paddingRight: 4,
          paddingBottom: 4,
          paddingLeft: 4,
        }
      } else if (val === 'normal') {
        this.theme.gapSet = {
          rowGap: 16,
          columnGap: 16,
          paddingTop: 16,
          paddingRight: 16,
          paddingBottom: 16,
          paddingLeft: 16,
        }
      } else if (val === 'self') {
        this.theme.gapSet = {
          rowGap: '',
          columnGap: '',
          paddingTop: '',
          paddingRight: '',
          paddingBottom: '',
          paddingLeft: '',
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-form-item__label {
  padding-left: 20px;
  font-size: 12px;
  height: fit-content;
}

.inline {
  display: flex;
  align-items: center;

  :deep(.el-input-number) {
    width: 50px;
  }
}

.card-margin {
  padding-left: 45px;

  .el-form-item__label {
    padding-left: 0;
  }
}
</style>